<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="course.course_name + ' - ' + course.FirstName + ' ' + course.LastName + ' [Employee Training Course] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/view/${course.training_course_id}`">
                             {{ course.course_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/employee/${course.id}/view`">
                            {{ course.completed_at | moment("MM/DD/YYYY") }} by {{ course.FirstName }} {{ course.LastName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-trash"></i> Delete
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Delete Employee Training Course</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to permanently delete this Employee Training Course. This cannot be undone.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteEmpTrainingCourse()" :disabled="deleting">
                                <template v-if="deleting">
                                    Deleting <i class="fa fa-spin fa-spinner"></i>
                                </template>
                                <template v-else>
                                    Delete Employee Training Course
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                course: {},
                files: [],
            }
        },

        computed: {

        },

        methods: {

            getEmpTrainingCourse(){
                //Get the data
                this.$http
                    .get('/training-courses/employee/' + this.id + '/view')
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            deleteEmpTrainingCourse(){
                //SEtup
                this.deleting = true;

                //Get the data
                this.$http
                    .post('/training-courses/employee/' + this.id + '/delete')
                    .then(response => {
                        //Alert the User
                        this.$toastr.success('Course Deleted');

                        //Redirect
                        this.$router.push('/training-courses/view/'+this.course.training_course_id);
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.deleting = false;
                    });
            },

        },

        mounted() {
            //Get the Training Course
            this.getEmpTrainingCourse();
        }
    }
</script>
